import styled, { css } from 'styled-components';
import { margin, MarginProps } from 'styled-system';

export const Separator = styled.div<MarginProps>`
  width: 100%;
  height: 1px;

  ${({ theme }) =>
    css`
      background-color: ${theme.colors.white.main};
    `};

  ${margin};
`;

export const Container = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.colors.primary.extraLight};
    border-radius: ${theme.radii[3]}px;
  `};
`;
